/**
 * Shared desktop theme tokens for layout and UI consistency.
 * Used by Sidebar, TopBar, and desktop screens.
 */
export const theme = {
  bg: '#F5F6FA',
  surface: '#FFFFFF',
  card: '#FFFFFF',
  hover: '#F0F1F5',
  accent: '#D23A3B',
  accentSoft: 'rgba(210,58,59,0.08)',
  accentGlow: 'rgba(210,58,59,0.15)',
  green: '#16A34A',
  greenSoft: 'rgba(22,163,74,0.08)',
  red: '#DC2626',
  redSoft: 'rgba(220,38,38,0.08)',
  orange: '#D97706',
  orangeSoft: 'rgba(217,119,6,0.08)',
  t1: '#1A1D2E',
  t2: '#5A6178',
  t3: '#9CA3B8',
  border: '#E2E5EC',
  div: '#E8EAF0',
  cardBorder: '#E2E5EC',
  divider: '#E8EAF0',
  sh: '0 1px 4px rgba(0,0,0,0.05)',
  shadow: '0 1px 4px rgba(0,0,0,0.05)',
  sbSh: '2px 0 8px rgba(0,0,0,0.03)',
  sidebarShadow: '2px 0 8px rgba(0,0,0,0.03)',
  tbSh: '0 1px 3px rgba(0,0,0,0.04)',
  topbarShadow: '0 1px 3px rgba(0,0,0,0.04)',
  f: "'DM Sans',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",
  font: "'DM Sans',-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",
};

export type Theme = typeof theme;
export default theme;
